import {
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILURE,
  GET_CATALOG,
  GET_CATALOG_SUCCESS,
  GET_CATALOG_FAILURE,
  RESET_RBAC,
} from "../constants/Rbac";

const INIT_STATE = { roles: [], catalog: [], loadingRoles: false, loadingCatalog: false, error: null };

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_RBAC:
      return INIT_STATE;
    case GET_ROLES:
      return { ...state, loadingRoles: true, error: null };
    case GET_ROLES_SUCCESS: {
      // The API helper returns the response body even on non-2xx (e.g. 403), so guard
      // against a non-array payload to keep `roles` always iterable for consumers.
      const rolesPayload = action?.payload?.payload ?? action?.payload;
      return { ...state, loadingRoles: false, roles: Array.isArray(rolesPayload) ? rolesPayload : [] };
    }
    case GET_ROLES_FAILURE:
      return { ...state, loadingRoles: false, error: "Error getting roles" };
    case GET_CATALOG:
      return { ...state, loadingCatalog: true, error: null };
    case GET_CATALOG_SUCCESS: {
      const catalogPayload = action?.payload?.payload ?? action?.payload;
      return { ...state, loadingCatalog: false, catalog: Array.isArray(catalogPayload) ? catalogPayload : [] };
    }
    case GET_CATALOG_FAILURE:
      return { ...state, loadingCatalog: false, error: "Error getting catalog" };
    default:
      return state;
  }
};
